import { render, staticRenderFns } from "./ChartList.vue?vue&type=template&id=4b15afc4&"
import script from "./ChartList.vue?vue&type=script&lang=js&"
export * from "./ChartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports